<template>
    <a-modal title="ECG数据"
             :width="1200"
             :visible="visible"
             @cancel="close"
             @ok="close">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="5" :sm="24">
              <a-form-item label="用户昵称" prop="nickname">
                <a-input v-model="queryParam.nickname" placeholder="请输入用户昵称" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="5" :sm="24">
              <a-form-item label="用户手机号" prop="mobile">
                <a-input v-model="queryParam.mobile" placeholder="请输入用户手机号" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="5" :sm="24">
              <a-form-item label="查询时间" prop="createTime">
                <a-date-picker style="width: 100%" v-model="queryParam.createTime" format="YYYY-MM-DD" allow-clear/>
              </a-form-item>
            </a-col>
            <template v-if="advanced">

            </template>
            <a-col :md="!advanced && 8 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
<!--                <a @click="toggleAdvanced" style="margin-left: 8px">-->
<!--                  {{ advanced ? '收起' : '展开' }}-->
<!--                  <a-icon :type="advanced ? 'up' : 'down'"/>-->
<!--                </a>-->
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">

        <a-button type="primary" @click="handleExport" v-hasPermi="['joe:ecg:export']">
          <a-icon type="download" />导出
        </a-button>
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :scroll="{ x: 3000 }"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="operation" slot-scope="text, record">
          <a-divider type="vertical" v-hasPermi="['joe:ecg:edit']" />
          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['joe:ecg:edit']">
            <a-icon type="edit" />修改
          </a>
          <a-divider type="vertical" v-hasPermi="['joe:ecg:remove']" />
          <a @click="handleDelete(record)" v-hasPermi="['joe:ecg:remove']">
            <a-icon type="delete" />删除
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-modal>
</template>

<script>
import { pageEcg,listEcg, delEcg } from '@/api/joe/ecg'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'
import moment from "moment";

export default {
  name: 'Ecg',
  components: {
    CreateForm
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      visible: false,
      userId: null,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        userId: null,
        heartRate: null,
        maxHeartRate: null,
        nickname: null,
        mobile: null,
        minHeartRate: null,
        frequency: null,
        walkingSpeed: null,
        gain: null,
        hrv: null,
        pwv: null,
        qtc: null,
        qrsWaveAmplitude: null,
        qrsWaveTime: null,
        qrsWaveDirection: null,
        st: null,
        diseaseRisk: null,
        pressureIndex: null,
        fatigueIndex: null,
        myocarditisRisk: null,
        coronaryHeartDisease: null,
        angiosclerosisRisk: null,
        wavePpt: null,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: '用户昵称',
          dataIndex: 'nickname',

          align: 'center'
        },
        {
          title: '用户手机号',
          dataIndex: 'mobile',

          align: 'center'
        },
        {
          title: '平均心率(次/分钟)',
          dataIndex: 'heartRate',
          align: 'center'
        },
        {
          title: '最高心率(次/分钟)',
          dataIndex: 'maxHeartRate',

          align: 'center'
        },
        {
          title: '最低心率(次/分钟)',
          dataIndex: 'minHeartRate',

          align: 'center'
        },
        {
          title: '频率(Hz)',
          dataIndex: 'frequency',

          align: 'center'
        },
        {
          title: '走速(mm/s)',
          dataIndex: 'walkingSpeed',

          align: 'center'
        },
        {
          title: '增益(mm/mv)',
          dataIndex: 'gain',

          align: 'center'
        },
        {
          title: '心率变异性HRV(毫秒)',
          dataIndex: 'hrv',

          align: 'center'
        },
        {
          title: '心电图PWV(m/s)',
          dataIndex: 'pwv',

          align: 'center'
        },
        {
          title: '心电图QTC(毫秒)',
          dataIndex: 'qtc',

          align: 'center'
        },
        {
          title: '心电图QRC波振幅(mv)',
          dataIndex: 'qrsWaveAmplitude',

          align: 'center'
        },
        {
          title: '心电图QRC波时限(毫秒)',
          dataIndex: 'qrsWaveTime',

          align: 'center'
        },
        {
          title: '心电图QRC主波方向',
          dataIndex: 'qrsWaveDirection',
          customRender: function (t) {
            if(t == 0) {
              return '向上'
            } else {
              return '向下'
            }
          },
          align: 'center'
        },
        {
          title: '心电图ST段振幅(mV)',
          dataIndex: 'st',

          align: 'center'
        },
        {
          title: '疾病风险',
          dataIndex: 'diseaseRisk',

          align: 'center'
        },
        {
          title: '压力指数',
          dataIndex: 'pressureIndex',

          align: 'center'
        },
        {
          title: '疲劳指数',
          dataIndex: 'fatigueIndex',

          align: 'center'
        },
        {
          title: '心肌炎风险',
          dataIndex: 'myocarditisRisk',

          align: 'center'
        },
        {
          title: '冠心病风险',
          dataIndex: 'coronaryHeartDisease',

          align: 'center'
        },
        {
          title: '血管硬化风险',
          dataIndex: 'angiosclerosisRisk',

          align: 'center'
        },

        {
          title: '创建时间',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },

          align: 'center'
        },
        // {
        //   title: '备注',
        //   dataIndex: 'remark',
        //
        //   align: 'center'
        // },
        // {
        //   title: '操作',
        //   dataIndex: 'operation',
        //   width: '18%',
        //   scopedSlots: { customRender: 'operation' },
        //   align: 'center'
        // }
      ]
    }
  },
  filters: {
  },
  created () {
    this.getList()
  },
  computed: {
  },
  watch: {
  },
  methods: {
    getUserBody(record) {
      this.userId = record
      this.visible = true
      this.getList()
    },
    close() {
      this.visible = false
      this.$emit('close')
    },
    /** 查询用户心电ECG记录列表 */
    getList () {
      this.loading = true
      this.queryParam.userId = this.userId
      if (moment.isMoment(this.queryParam.createTime)) {
        this.queryParam.createTime = this.queryParam.createTime.format('YYYY-MM-DD')
      }
     pageEcg(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        userId: undefined,
        heartRate: undefined,
        maxHeartRate: undefined,
        minHeartRate: undefined,
        frequency: undefined,
        walkingSpeed: undefined,
        gain: undefined,
        hrv: undefined,
        pwv: undefined,
        qtc: undefined,
        qrsWaveAmplitude: undefined,
        qrsWaveTime: undefined,
        qrsWaveDirection: undefined,
        st: undefined,
        diseaseRisk: undefined,
        pressureIndex: undefined,
        fatigueIndex: undefined,
        myocarditisRisk: undefined,
        coronaryHeartDisease: undefined,
        angiosclerosisRisk: undefined,
        wavePpt: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if(row.id){
        this.ids.push(row.id)
      }
      this.$confirm({
        title: '确认删除所选中数据?',
        content: '当前选中编号为' + ids + '的数据',
        onOk () {
          let data = []
          that.ids.map(id => data.push({"id":id}))
          return delEcg(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                '删除成功',
                3
              )
          })
        },
        onCancel () {
          //取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      that.queryParam.userId = this.userId
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk () {
          that.download('joe/user-ecg/export', {
            ...that.queryParam
          }, `用户心电ECG记录_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    }
  }
}
</script>
<style scoped>
.modal-footer {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
}

.pagination-container {
  margin-top: 20px;
  padding-bottom: 20px;
  display: flex;
  justify-content: center;
}

.ant-table-pagination {
  display: flex;
  justify-content: center;
  margin-top: 16px;
}

.ant-pagination {
  display: inline-block;
  margin: 0 auto;
}
</style>